import { render } from "./InformesPage.vue?vue&type=template&id=55e995fc"
import script from "./InformesPage.vue?vue&type=script&lang=js"
export * from "./InformesPage.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__